import React, { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useTenantStore } from '../stores/useTenantStore';

const LoginPage: React.FC = () => {
  const auth = useAuth();
  const { isLoading, error } = useTenantStore();
  const [loginError, setLoginError] = useState<string | null>(null);

  const handleLogin = async () => {
    try {
      setLoginError(null);
      await auth.signinRedirect();
    } catch (error) {
      console.error('Login failed:', error);
      setLoginError('Échec de la connexion. Veuillez réessayer.');
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <h1 style={{ marginBottom: '2rem', color: '#333' }}>Chat UI</h1>
        <p style={{ marginBottom: '2rem', color: '#666' }}>
          Connectez-vous pour continuer
        </p>

        {(loginError || error) && (
          <div style={{
            backgroundColor: '#ffebee',
            color: '#c62828',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '1rem',
            fontSize: '14px'
          }}>
            {loginError || error}
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={isLoading}
          style={{
            backgroundColor: isLoading ? '#ccc' : '#E85D04',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            margin: '0 auto'
          }}
        >
          {isLoading ? (
            <>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid white',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
              Configuration en cours...
            </>
          ) : (
            'Se connecter'
          )}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
